module.exports = __webpack_public_path__ + "img/RUN-FOREFOOT-A-GAUCHE.5e0028fd.svg";